import 'babel-polyfill';
import 'react-app-polyfill/ie11';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './app/App';
import {unregister} from './app/registerServiceWorker';

unregister();

ReactDOM.render(<App />, document.getElementById('wrapper'));



// WEBPACK FOOTER //
// ./src/index.js